<owc-icon-button *ngIf="!hideDefaultIconButton" [type]="type" flat [icon]="icon" id="owc-menu-{{index}}"
  (click)="menuVisible = !menuVisible;"></owc-icon-button>
<owc-menu anchor="owc-menu-{{index}}" [(ngModel)]="menuVisible" (clickOutside)="menuVisible = false;">
  <!-- Using content projection to display menu items -->
  <ng-content></ng-content>
</owc-menu>
